const fonts = [
    {
      "czcionkaId": 1,
      "opis": "Panele - domyslny Naglowek..........",
      "fontSize": "14",
      "fontWeight": "bold",
      "color": "#006010",
      "fontFamily": "",
      "aktywna": 0
    },
    {
      "czcionkaId": 2,
      "opis": "Panele - domyslna Tresc.............",
      "fontSize": "12",
      "fontWeight": "bold",
      "color": "#006010",
      "fontFamily": "",
      "aktywna": 0
    },
    {
       "czcionkaId": 3,
       "opis": "lewy panel - nawigacja dat",
    //   "fontSize": "13",
    //   "fontWeight": "bold",
      "color": "#006010",
    //   "fontFamily": "",
       "aktywna": 0
    },
    {
      "czcionkaId": 4,
      "opis": "środkowy panel - grafik zajętości",
    //  "fontSize": "13",
    //  "fontWeight": "bold",
      "color": "red",
    //  "fontFamily": "",
      "aktywna": 0
    },
    {
      "czcionkaId": 5,
      "opis": "prawy panel - kontakt z nami",
    //  "fontSize": "14",
    //  "fontWeight": "bold",
      "color": "#006010",
    //  "fontFamily": "",
      "aktywna": 0
    },
    {
      "czcionkaId": 6,
      "opis": "dolny panel - pokój (czcionki i buton)",
    //   "fontSize": "10",
    //  "fontWeight": "bold",
      "color": "red",
      //"fontFamily": "",
      "aktywna": 0
    },
  ]

export const fontSelect = (font: number, defaultFont: number = 2) => {
    if (fonts.length <= 0) {
      return {}
    }
    let style: any = {}
    if (fonts[font - 1].aktywna !== 0) {
      style = fonts[font - 1]
    } else if (fonts[defaultFont - 1].aktywna !== 0) {
      style = fonts[defaultFont - 1]
    } else {
      return {}
    }
    return {
      fontSize: `${style.fontSize}px`,
      fontWeight: style.fontWeight,
      color: style.color,
      //fontFamily: style.fontFamily + "," + theme.typography.fontFamily,
    }
  }
  